import {RouteEntry} from "../../shared/routes";
import {MyDelivery} from "./MyDelivery";

export const myDeliveryRoutes: Array<RouteEntry> = [
    { path: '/my-delivery/:id', component: MyDelivery },
    { path: '/my-delivery', component: MyDelivery },
];
